import React from 'react';
import PropTypes from 'prop-types';
import { Edit, SimpleForm, TextInput, AutocompleteInput, ReferenceInput, FunctionField, useTranslate, required, maxLength } from 'react-admin';
import { RightDrawer } from '@/components/global/drawers/RightDrawer.jsx';
import { Box } from '@mui/material';
import { promptModelFilterToQuery } from '@/helpers/filters/filterToQuery.js';
import { EditToolbar } from '@/components/global/buttons/toolbar.jsx';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';

export const PromptEdit = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <RightDrawer handleClose={handleClose} title={translate('resources.prompt.labels.editPrompt')}>
            <Edit
                id={elementId}
                resource='prompt'
                actions={false}
                toolbar={false}
                mutationMode='pessimistic'
                redirect={resource => {
                    handleClose();
                    return resource;
                }}
            >
                <SimpleForm toolbar={<EditToolbar label={translate('common.save')} icon={null} />}>
                    <TextInput source='customId' label={translate('resources.prompt.fields.customId')} fullWidth disabled />
                    <TextInput
                        source='name'
                        label={translate('resources.prompt.fields.name')}
                        fullWidth
                        validate={[required(translate('common.validation.required')), maxLength(255, translate('common.validation.maxLength', { count: 255 }))]}
                    />
                    <Box className='autocomplete-parent'>
                        <ReferenceInput source='model' reference='prompt-model'>
                            <AutocompleteInput
                                filterToQuery={promptModelFilterToQuery}
                                optionText={record => record.name}
                                validate={required(translate('common.validation.required'))}
                                fullWidth={true}
                                disablePortal={true}
                                label={translate('resources.prompt.fields.model')}
                            />
                        </ReferenceInput>
                    </Box>
                    <TextInput
                        source='content'
                        label={translate('resources.prompt.fields.content')}
                        fullWidth
                        multiline
                        minRows={6}
                        validate={[required(translate('common.validation.required'))]}
                    />
                    <NotificationBox variant='warning' className='large'>
                        {translate('resources.prompt.labels.availableVariables')}{' '}
                        <FunctionField
                            render={record =>
                                Array.isArray(record?.variables) && record.variables.length ? (
                                    <Box component='code' sx={{ fontFamily: 'monospace', display: 'block', marginTop: '10px' }}>
                                        {record.variables.map(variable => `{{${variable}}}`).join(', ')}
                                    </Box>
                                ) : (
                                    translate('common.noRecordsFound')
                                )
                            }
                        />
                    </NotificationBox>
                </SimpleForm>
            </Edit>
        </RightDrawer>
    );
};

PromptEdit.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.string,
};
